import { Component, computed, input } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import type { FormControl } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

import { map, startWith, switchMap } from 'rxjs';

import { injectDevFlag } from '@core/dev-flags-logic';
import { DevFlag } from '@core/dev-flags-types';
import { TranslatePipe } from '@core/i18n-legacy';
import {
  ProsemirrorGroupedConfig,
  ProsemirrorGroupedConfigDirective,
  WysiwygComponent,
} from '@core/prosemirror-legacy/webapp';
import type { EditorJSONState } from '@core/prosemirror-types';
import { BoxComponent, FormFieldComponent } from '@core/user-interface-legacy';
import {
  EvaluationFieldLabelComponent,
  EvaluationMultiLineFieldComponent,
} from '@recruitee/evaluations-ui';

@Component({
  selector: 'rt-evaluation-text-answer-field',
  templateUrl: './evaluation-text-answer-field.component.html',
  styleUrls: ['./evaluation-text-answer-field.component.less'],
  imports: [
    ReactiveFormsModule,
    TranslatePipe,
    BoxComponent,
    FormFieldComponent,
    WysiwygComponent,
    ProsemirrorGroupedConfigDirective,
    EvaluationFieldLabelComponent,
    EvaluationMultiLineFieldComponent,
  ],
})
export class EvaluationTextAnswerFieldComponent {
  protected readonly ProsemirrorGroupedConfig = ProsemirrorGroupedConfig;
  protected readonly useProsemirror = injectDevFlag(DevFlag.ProsemirrorInEvaluations);

  public readonly control = input.required<FormControl<string | null>>();
  public readonly jsonControl = input.required<FormControl<EditorJSONState | null>>();
  public readonly title = input<string>('');
  public readonly hint = input<string>('');
  public readonly required = input<boolean>(false);
  public readonly showValidationErrors = input<boolean>(false);

  protected isJsonInvalid = toSignal(
    toObservable(this.jsonControl).pipe(
      switchMap(control =>
        control.events.pipe(
          map(() => control.invalid),
          startWith(control.invalid),
        ),
      ),
    ),
    { initialValue: false },
  );

  protected hasError = computed(() => this.showValidationErrors() && this.isJsonInvalid());
}
